module.exports = __webpack_public_path__ + "static/media/banner_mapa.93aa7aaf.jpg";